module.exports = __webpack_public_path__ + "img/list-alt.669b99dc.svg";